import React, { useState } from 'react';
import {
  LineChart, Line, BarChart, Bar,
  XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from 'recharts';
import './TrendChart.css';

function TrendChart({ data }) {
  const [activeChart, setActiveChart] = useState('activity');

  const formatMonth = (month) => {
    if (!month) return '';
    const [year, m] = month.split('-');
    const names = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    return `${names[parseInt(m) - 1]} ${year.slice(2)}`;
  };

  const chartData = data.map(d => ({
    month: formatMonth(d.month),
    Projects: d.projects || 0,
    Beneficiaries: d.beneficiaries || 0,
    Received: Math.round((d.budget || 0) / 1000),
    Disbursed: Math.round((d.disbursed || 0) / 1000),
  }));

  return (
    <div className="trend-chart">
      <div className="chart-tabs">
        <button
          className={activeChart === 'activity' ? 'tab active' : 'tab'}
          onClick={() => setActiveChart('activity')}
        >
          Projects & Beneficiaries
        </button>
        <button
          className={activeChart === 'financial' ? 'tab active' : 'tab'}
          onClick={() => setActiveChart('financial')}
        >
          Financial (USD $K)
        </button>
      </div>

      {activeChart === 'activity' && (
        <ResponsiveContainer width="100%" height={320}>
          <LineChart data={chartData} margin={{ top: 5, right: 30, left: 0, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
            <XAxis dataKey="month" style={{ fontSize: 12 }} />
            <YAxis yAxisId="left" stroke="#c8102e" style={{ fontSize: 12 }} />
            <YAxis yAxisId="right" orientation="right" stroke="#00205b" style={{ fontSize: 12 }} />
            <Tooltip contentStyle={{ borderRadius: 8, border: '1px solid #eee' }} />
            <Legend />
            <Line yAxisId="left" type="monotone" dataKey="Projects"
              stroke="#c8102e" strokeWidth={3} dot={{ r: 5 }} activeDot={{ r: 7 }} />
            <Line yAxisId="right" type="monotone" dataKey="Beneficiaries"
              stroke="#00205b" strokeWidth={3} dot={{ r: 5 }} activeDot={{ r: 7 }} />
          </LineChart>
        </ResponsiveContainer>
      )}

      {activeChart === 'financial' && (
        <ResponsiveContainer width="100%" height={320}>
          <BarChart data={chartData} margin={{ top: 5, right: 30, left: 0, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
            <XAxis dataKey="month" style={{ fontSize: 12 }} />
            <YAxis style={{ fontSize: 12 }} tickFormatter={v => `$${v}K`} />
            <Tooltip formatter={v => `$${v}K`} contentStyle={{ borderRadius: 8 }} />
            <Legend />
            <Bar dataKey="Received" fill="#27ae60" radius={[4, 4, 0, 0]} />
            <Bar dataKey="Disbursed" fill="#c8102e" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
}

export default TrendChart;
